import styled from "@emotion/styled";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div<{ full?: boolean }>`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.2);
  width: ${({ full }) => (full ? "98vw" : "700px")};
  height: ${({ full }) => (full ? "98vh" : "auto")};
  max-width: 98vw;
  max-height: 98vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem 1rem 1.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  border-bottom: 1px solid #eee;
`;

export const ModalClose = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
  margin-left: 1rem;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
`;
